import { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { Theme } from '../constants/theme';

export const useThemeContext = () => useContext(ThemeContext) as Theme;
